<template>
  <div>
    <b-card
      bg-variant="danger"
      text-variant="white"
      class="text-left margin-bottom"
    >
      <b-row>
        <b-col lg="3">
          {{ vnChang }}
          <h5>AN : {{ this.ptAdmitData && this.ptAdmitData.datas.an }}</h5>
        </b-col>
        <b-col lg="3">
          <h5>HN : {{ this.ptData && this.ptData.datas.hn }}</h5>
        </b-col>
        <b-col>
          <h5>
            ชื่อ-สกุล
            {{
              this.ptData &&
                this.ptData.datas.pname +
                  this.ptData.datas.fname +
                  "  " +
                  this.ptData.datas.lname
            }}
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3">
          <h5>CID : {{ this.ptAdmitData && this.ptAdmitData.datas.cid }}</h5>
        </b-col>
        <b-col lg="3">
          <h6>
            วันที่รับ :
            {{
              this.ptAdmitData &&
                this.thaiDatetimeFc.ThaiDateTime(
                  this.ptAdmitData.datas.regdate +
                    " " +
                    this.ptAdmitData.datas.regtime
                )
            }}
          </h6>
        </b-col>
        <b-col>
          <h6>
            วันที่จำหน่วย :
            {{
              this.ptAdmitData &&
                this.thaiDatetimeFc.ThaiDateTime(
                  this.ptAdmitData.datas.dchdate +
                    " " +
                    this.ptAdmitData.datas.dchtime
                )
            }}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6 class="font-color-warning2">
            อาการสำคัญ :
            {{ this.ptAdmitData && this.ptAdmitData.datas.prediag }}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4">
          <h6>
            แพทย์เจ้าของไข้ :
            {{
              this.ptAdmitData && this.ptAdmitData.datas.incharge_doctor_name
            }}
          </h6>
        </b-col>
        <b-col lg="4">
          <h6>
            Ward : {{ this.ptAdmitData && this.ptAdmitData.datas.ward_name }}
          </h6>
        </b-col>
        <b-col>
          <h6>
            แผนก : {{ this.ptAdmitData && this.ptAdmitData.datas.spclty_name }}
          </h6>
        </b-col>
      </b-row>

      <b-row v-if="this.ptData && this.ptData.datas.clinic.length > 2">
        <b-col>
          <h5 class="font-color-warning2">
            โรคประจำตัว : {{ this.ptData && this.ptData.datas.clinic }}
          </h5>
        </b-col>
      </b-row>

      <b-row v-if="this.ptData && this.ptData.datas.drugallergy">
        <b-col>
          <h5 class="font-color-warning2">
            แพ้ยา : {{ this.ptData && this.ptData.datas.drugallergy }}
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6>
            สิทธิประจำตัว :
            {{
              this.ptData &&
                this.pjFunctionsFc.NulltoStr(this.ptData.datas.pttype) +
                  " " +
                  this.pjFunctionsFc.NulltoStr(this.ptData.datas.pttype_name)
            }}
          </h6>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="text-left margin-bottom" bg-variant="secondary">
      <h6>
        สิทธิการรักษา :
        {{
          this.ptAdmitData &&
            this.ptAdmitData.datas.pttype +
              " " +
              this.ptAdmitData.datas.pttype_name
        }}
      </h6>
      <b-col lg="6">
        <h6>
          สถานพยาบาลหลัก :
          {{ this.ptAdmitData && this.ptAdmitData.datas.hospmain_name }}
        </h6>
      </b-col>
      <b-col lg="6">
        <h6>
          สถานพยาบาลรอง :
          {{ this.ptAdmitData && this.ptAdmitData.datas.hospsub_name }}
        </h6>
      </b-col>
    </b-card>

    <b-card
      bg-variant="info"
      header="ตรวจสอบสิทธิ"
      text-variant="white"
      class="text-left margin-bottom"
    >
      <b-card-text>
        <b-form>
          <b-list-group>
            <b-list-group-item
              v-for="item in RightsCenterChoice"
              v-bind:key="item.id"
            >
              <b-row>
                <b-col lg="4">
                  <b-alert show variant="success">
                    <b-form-checkbox-group
                      id="checkbox-rights-center-choice"
                      v-model="selectedRightsCenterChoice"
                      name="checkbox-rights-center-choice"
                    >
                      <b-form-checkbox :value="item.datas.emr_ipd_rights_id">
                        {{ item.datas.emr_ipd_rights_name }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-alert>
                </b-col>
                <b-col lg="4">
                  <b-alert
                    show
                    variant="warning"
                    v-for="item2 in getRightsCenterChoiceL1(
                      item.datas.emr_ipd_rights_id
                    )"
                    v-bind:key="item2.id"
                  >
                    <b-form-checkbox-group
                      id="checkbox-rights-center-choice-l1"
                      v-model="selectedRightsCenterChoiceL1"
                      name="checkbox-rights-center-choice-l1"
                    >
                      <b-form-checkbox
                        :value="item2.datas.emr_ipd_rights_level1_id"
                      >
                        {{ item2.datas.emr_ipd_rights_level1_name }}
                      </b-form-checkbox>

                      <div v-if="item2.datas.emr_ipd_rights_level1_note == 'Y'">
                        <div
                          v-for="item3 in pjFunctionsFc.Arrayfilter(
                            selectedRightsCenterL1Note,
                            item2.datas.emr_ipd_rights_level1_id
                          )"
                          v-bind:key="item3.id"
                        >
                          <b-form-textarea
                            v-model="item3.value"
                          ></b-form-textarea>
                        </div>
                      </div>
                    </b-form-checkbox-group>
                  </b-alert>
                </b-col>
                <b-col lg="4">
                  <b-alert
                    show
                    variant="danger"
                    v-for="item3 in getRightsCenterChoiceL2(
                      item.datas.emr_ipd_rights_id
                    )"
                    v-bind:key="item3.id"
                  >
                    <b-form-checkbox-group
                      id="checkbox-rights-center-choice-l2"
                      v-model="selectedRightsCenterChoiceL2"
                      name="checkbox-rights-center-choice-l2"
                    >
                      <b-form-checkbox
                        :value="item3.datas.emr_ipd_rights_level2_id"
                      >
                        {{ item3.datas.emr_ipd_rights_level2_name }}
                      </b-form-checkbox>

                      <div v-if="item3.datas.emr_ipd_rights_level2_note == 'Y'">
                        <div
                          v-for="item4 in pjFunctionsFc.Arrayfilter(
                            selectedRightsCenterL2Note,
                            item3.datas.emr_ipd_rights_level2_id
                          )"
                          v-bind:key="item4.id"
                        >
                          <b-form-textarea
                            v-model="item4.value"
                          ></b-form-textarea>
                        </div>
                      </div>
                    </b-form-checkbox-group>
                  </b-alert>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-form>
      </b-card-text>
    </b-card>

    <b-card
      bg-variant="warning"
      header="Note :"
      text-variant="dark"
      class="text-left margin-bottom"
    >
      <b-card-text>
        <b-form-textarea
          id="rights-center-choice-note"
          v-model="RightsCenterChoiceNote"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-card-text>
    </b-card>

    <div class="font12px">User log : {{ UserEdit }}</div>

    <div class="d-block text-center">
      <b-button
        variant="success"
        size="sm"
        @click="SubmitConfirm(ptAN, 'Add', 'ยืนยันการบันทึกข้อมูล !')"
        v-if="ModulRightCheck"
        >บันทึก</b-button
      >
      &nbsp;
      <b-button size="sm" @click="$bvModal.hide('modal-admit-rights-data')"
        >ยกเลิก</b-button
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import PatientData from "@/models/patientEMRs/PatientData";
import PatientAdmitData from "@/models/patientEMRs/PatientAdmitData";
import PatientAdmitDiagData from "@/models/patientEMRs/PatientAdmitDiagData";
import PatientAdmitOperationData from "@/models/patientEMRs/PatientAdmitOperationData";
import PatientDrugNoneDrug from "@/models/patientEMRs/PatientDrugNoneDrug";
import PatientAdmitRxOrderData from "@/models/patientEMRs/PatientAdmitRxOrderData";
import PatientAdmitDischargeSummary from "@/models/patientEMRs/PatientAdmitDischargeSummary";
import PatientAdmitDischargeType from "@/models/patientEMRs/PatientAdmitDischargeType";
import PatientAdmitDischargeStatus from "@/models/patientEMRs/PatientAdmitDischargeStatus";
import PatientAdmitRightsCenterChoice from "@/models/patientEMRs/PatientAdmitRightsCenterChoice";
import PatientAdmitRightsCenterChoiceL1 from "@/models/patientEMRs/PatientAdmitRightsCenterChoiceL1";
import PatientAdmitRightsCenterChoiceL2 from "@/models/patientEMRs/PatientAdmitRightsCenterChoiceL2";

import PatientAdmitRightsCenterList from "@/models/patientEMRs/PatientAdmitRightsCenterList";
import PatientAdmitRightsCenterListL1 from "@/models/patientEMRs/PatientAdmitRightsCenterListL1";
import PatientAdmitRightsCenterListL2 from "@/models/patientEMRs/PatientAdmitRightsCenterListL2";

import EmrXrayIPD from "@/components/PatientEMR/EmrXrayIPD";
import EmrLabIPD from "@/components/PatientEMR/EmrLabIPD";

import PatientAdmitRightsCenterHead from "@/models/patientEMRs/PatientAdmitRightsCenterHead";

Vue.component("EmrXrayIPD", EmrXrayIPD);
Vue.component("EmrLabIPD", EmrLabIPD);
Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      form: {},
      ModulRightCheck: false,
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      ptHN: "",
      ptVN: "",
      ptAN: "",
      ptData: null,
      ptAdmitData: null,
      ptAdmitDiagData: null,
      ptAdmitOperationData: null,
      ptAdmitHomeMedData: null,
      ptAdmitRxOrderData: null,
      ptAdmitDischargeSummary: null,
      UserAdmitDischargeSummary: null,
      ptAdmitDischargeType: null,
      ptAdmitDischargeStatus: null,
      ptAdmitDischargeTypeSelect: "",
      ptAdmitDischargeStatusSelect: "",
      primary_diagnosis: "",
      comorbidity: "",
      complication: "",
      others_diag: "",
      course_progressnote: "",
      anesthetic_note: "",
      operation_procedure: "",
      operation_findings: "",
      doctor_note: "",
      dchtype_text: "",
      RightsCenterChoice: null,
      RightsCenterChoiceL1: null,
      RightsCenterChoiceL2: null,
      selectedRightsCenterChoice: [],
      selectedRightsCenterChoiceL1: [],
      selectedRightsCenterChoiceL2: [],
      selectedRightsCenterL1Note: null,
      selectedRightsCenterL2Note: null,
      RightsCenterChoiceNote: "",
      UserEdit: ""
    };
  },
  props: ["MyVn", "MyHn", "MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientData,
    PatientAdmitData,
    PatientAdmitDiagData,
    PatientAdmitOperationData,
    PatientDrugNoneDrug,
    PatientAdmitRxOrderData,
    PatientAdmitDischargeSummary,
    PatientAdmitDischargeType,
    PatientAdmitDischargeStatus,
    PatientAdmitRightsCenterChoice,
    PatientAdmitRightsCenterChoiceL1,
    PatientAdmitRightsCenterChoiceL2,
    PatientAdmitRightsCenterList,
    PatientAdmitRightsCenterListL1,
    PatientAdmitRightsCenterListL2
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
  },
  watch: {
    MyVn: function() {
      this.vnChang;
    },
    MyHn: function() {
      this.vnChang;
    },
    MyAn: function() {
      this.vnChang;
    },
    ptVN: function() {
      this.getData(this.ptVN, this.ptHN, this.ptAN, "ptData");
    },
    ptAN: function() {
      this.setData(this.ptVN, this.ptHN, this.ptAN);
      this.getData(this.ptVN, this.ptHN, this.ptAN, "ptData");

      this.getRightsCenter(this.ptHN, this.ptAN, "RightsCenterList");
      this.getRightsCenter(this.ptHN, this.ptAN, "RightsCenterListL1");
      this.getRightsCenter(this.ptHN, this.ptAN, "RightsCenterListL2");

      this.getRightsCenterChoice();
      this.chkUserModulRightCheck();

      /*
        this.getData(this.ptVN,this.ptHN,this.ptAN,'AdmitDischargeType')
        
        this.getData(this.ptVN,this.ptHN,this.ptAN,'AdmitDischargeStatus')*/
    }
  },
  computed: {
    vnChang: function() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.ptAN = this.MyAn;

      this.getData(this.MyVn, this.MyHn, this.MyAn, "AdmitDischargeType");
      this.getData(this.MyVn, this.MyHn, this.MyAn, "AdmitDischargeStatus");
    }
  },
  methods: {
    chkUserModulRightCheck() {
      if (this.$store.get("systems@LoginStatus")) {
        if (
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "RightIPD"
          ) ||
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "Admin"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "ADMIN"
          )
        ) {
          this.ModulRightCheck = true;
        } else {
          this.ModulRightCheck = false;
        }
      } else {
        this.ModulRightCheck = false;
      }
    },
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    SubmitConfirm(an, action, msgText) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm(msgText, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.SubmitRightsCenter(an, action);
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    SubmitRightsCenter(an, action) {
      if (an != "" && action != "") {
        if (action == "Add") {
          let emr_ipd_rights_head = [
            {
              an: an,
              hn: this.ptHN,
              emr_ipd_rights_note: this.RightsCenterChoiceNote
            }
          ];

          let rights_level1_list_data = [];
          for (let val1 of this.selectedRightsCenterChoiceL1) {
            rights_level1_list_data.push({
              emr_ipd_rights_level1_id: val1,
              emr_ipd_rights_level1_note: this.pjFunctionsFc.Arrayfilter(
                this.selectedRightsCenterL1Note,
                val1
              )[0].value
            });
          }

          let rights_level2_list_data = [];
          for (let val2 of this.selectedRightsCenterChoiceL2) {
            rights_level2_list_data.push({
              emr_ipd_rights_level2_id: val2,
              emr_ipd_rights_level2_note: this.pjFunctionsFc.Arrayfilter(
                this.selectedRightsCenterL2Note,
                val2
              )[0].value
            });
          }

          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            emr_ipd_rights_head: emr_ipd_rights_head,
            emr_ipd_rights_list: this.selectedRightsCenterChoice,
            emr_ipd_rights_level1_list: rights_level1_list_data,
            emr_ipd_rights_level2_list: rights_level2_list_data
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "AdmitRightsCenterDataAdd",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);

                ScrObj.show(
                  "notifi-main-top-right",
                  "success",
                  "Save Data Success",
                  "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                ScrObj.$bvModal.hide("modal-admit-rights-data");
              } else {
                ScrObj.show(
                  "notifi-main-top-right",
                  "warn",
                  "Save Data Error",
                  "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log("AdmitDischargeSummaryAction : " + ScrObj.output);
            });
        }

        if (action == "DeleteDischargeSummary") {
          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            primary_diagnosis: this.primary_diagnosis,
            comorbidity: this.comorbidity,
            complication: this.complication,
            others_diag: this.others_diag,
            course_progressnote: this.course_progressnote,
            anesthetic_note: this.anesthetic_note,
            operation_procedure: this.operation_procedure,
            operation_findings: this.operation_findings,
            doctor_note: this.doctor_note,
            doctor_dchstts: this.ptAdmitDischargeStatusSelect,
            doctor_dchtype: this.ptAdmitDischargeTypeSelect,
            dchtype_text: this.dchtype_text,
            action: action
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "AdmitDischargeSummaryAction",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);

                ScrObj.show(
                  "ansn-foo-css",
                  "success",
                  "Save Data Success",
                  "การลบข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                ScrObj.$bvModal.hide("modal-admit-rights-data");
              } else {
                ScrObj.show(
                  "ansn-foo-css",
                  "warn",
                  "Save Data Error",
                  "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log("AdmitDischargeSummaryAction : " + ScrObj.output);
            });
        }
      }
    },
    setData(vn, hn, an) {
      if (hn != "" && an != "" && an != null && an != "null") {
        let data = [];
        let DataObj = this;

        /** Admit Data Load */
        DataObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitData.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id: val.an,
                  an: val.an,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientAdmitData.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitData.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("AdmitData : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(vn, hn, an, "ptAdmit");
          });

        /** Admit Rights Center Data */
        DataObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitRightsCenterData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitRightsCenterHead.delete({
                where(record) {
                  return record.hn == hn;
                }
              });

              data = [];
              for (val of DataObj.output.result.RightsCenterData
                .emr_ipd_rights_head) {
                data.push({
                  id: val.an + val.user_edit + val.emr_ipd_rights_head_status,
                  an: val.an,
                  hn: val.hn,
                  emr_ipd_rights_head_status: val.emr_ipd_rights_head_status,
                  datas: val
                });
              }

              PatientAdmitRightsCenterHead.insertOrUpdate({
                data
              });

              PatientAdmitRightsCenterList.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result.RightsCenterData
                .emr_ipd_rights_list) {
                data.push({
                  id: an + val.emr_ipd_rights_id,
                  emr_ipd_rights_id: val.emr_ipd_rights_id,
                  an: an,
                  hn: hn,
                  datas: val
                });
              }

              PatientAdmitRightsCenterList.insertOrUpdate({
                data
              });

              PatientAdmitRightsCenterListL1.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val2 of DataObj.output.result.RightsCenterData
                .emr_ipd_rights_level1_list) {
                data.push({
                  id: an + val2.emr_ipd_rights_level1_id,
                  emr_ipd_rights_level1_id: val2.emr_ipd_rights_level1_id,
                  an: an,
                  hn: hn,
                  datas: val2
                });
              }

              PatientAdmitRightsCenterListL1.insertOrUpdate({
                data
              });

              PatientAdmitRightsCenterListL2.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val3 of DataObj.output.result.RightsCenterData
                .emr_ipd_rights_level2_list) {
                data.push({
                  id: an + val3.emr_ipd_rights_level2_id,
                  emr_ipd_rights_level2_id: val3.emr_ipd_rights_level2_id,
                  an: an,
                  hn: hn,
                  datas: val3
                });
              }

              PatientAdmitRightsCenterListL2.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitRightsCenterHead.delete({
                  where(record) {
                    return record.hn == hn;
                  }
                });

                PatientAdmitRightsCenterList.delete({
                  where(record) {
                    return record.an == an;
                  }
                });

                PatientAdmitRightsCenterListL1.delete({
                  where(record) {
                    return record.an == an;
                  }
                });

                PatientAdmitRightsCenterListL2.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("AdmitData : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(vn, hn, an, "ptAdmit");
            DataObj.getData(vn, hn, an, "getChoiceL1");
            DataObj.getData(vn, hn, an, "getChoiceL2");

            DataObj.getRightsCenter(hn, an, "RightsCenterHead");
            DataObj.getRightsCenter(hn, an, "RightsCenterList");
            DataObj.getRightsCenter(hn, an, "RightsCenterListL1");
            DataObj.getRightsCenter(hn, an, "RightsCenterListL2");
          });
      }
    },
    getData(vn, hn, an, act) {
      let DataObj = null;
      let val = null;

      if (hn != "" && act == "ptData") {
        DataObj = null;
        DataObj = PatientData.query()
          .where(record => record.id == hn)
          .get();
        if (DataObj.length > 0) {
          this.ptData = DataObj[0];
        } else {
          this.ptData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmit") {
        /** get Admit Data */
        DataObj = null;
        DataObj = PatientAdmitData.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .get();
        if (DataObj.length > 0) {
          this.ptAdmitData = DataObj[0];
        } else {
          this.ptAdmitData = null;
        }
      }

      if (hn != "" && an != "" && act == "getChoiceL1") {
        let DataObj = null;
        let DataObj2 = null;
        let data2 = "";
        let data3 = "";
        DataObj = PatientAdmitRightsCenterChoiceL1.query()
          .where(record => record.emr_ipd_rights_level1_status == "Y")
          .orderBy(record => record.emr_ipd_rights_level1_number)
          .get();
        if (DataObj.length > 0) {
          let data = [];
          for (var val1 of DataObj) {
            data2 = "";
            data3 = "";
            DataObj2 = PatientAdmitRightsCenterListL1.query()
              .where(record => record.an == an)
              .where(record => record.hn == hn)
              .where(
                record =>
                  record.emr_ipd_rights_level1_id ==
                  val1.emr_ipd_rights_level1_id
              )
              .get();
            if (DataObj2.length > 0) {
              data2 = DataObj2[0].datas.emr_ipd_rights_level1_note;
            } else {
              data2 = "";
            }

            data.push({
              id: val1.emr_ipd_rights_level1_id,
              value: data2
            });
          }

          this.selectedRightsCenterL1Note = data;
        }
      }

      if (hn != "" && an != "" && act == "getChoiceL2") {
        let DataObj = null;
        let DataObj2 = null;
        let data2 = "";
        let data3 = "";
        DataObj = PatientAdmitRightsCenterChoiceL2.query()
          .where(record => record.emr_ipd_rights_level2_status == "Y")
          .orderBy(record => record.emr_ipd_rights_level2_number)
          .get();
        if (DataObj.length > 0) {
          let data = [];
          for (var val2 of DataObj) {
            data2 = "";
            data3 = "";
            DataObj2 = PatientAdmitRightsCenterListL2.query()
              .where(record => record.an == an)
              .where(record => record.hn == hn)
              .where(
                record =>
                  record.emr_ipd_rights_level2_id ==
                  val2.emr_ipd_rights_level2_id
              )
              .get();
            if (DataObj2.length > 0) {
              data2 = DataObj2[0].datas.emr_ipd_rights_level2_note;
            } else {
              data2 = "";
            }

            data.push({
              id: val2.emr_ipd_rights_level2_id,
              value: data2
            });
          }

          this.selectedRightsCenterL2Note = data;
        }
      }
    },
    getRightsCenterChoice() {
      /** get Rights Center Choice */
      let DataObj = null;
      DataObj = PatientAdmitRightsCenterChoice.query()
        .where(record => record.emr_ipd_rights_status == "Y")
        .orderBy("emr_ipd_rights_number")
        .get();
      if (DataObj.length > 0) {
        this.RightsCenterChoice = DataObj;
      } else {
        this.RightsCenterChoice = null;
      }
    },
    getRightsCenterChoiceL1(ch) {
      /** get Rights Center Choice L1 */
      let DataObj = null;
      DataObj = PatientAdmitRightsCenterChoiceL1.query()
        .where(record => record.emr_ipd_rights_level1_status == "Y")
        .where(record => record.emr_ipd_rights_id == ch)
        .orderBy(record => record.emr_ipd_rights_level1_number)
        .get();
      if (DataObj.length > 0) {
        return DataObj;
      } else {
        return null;
      }
    },
    getRightsCenterChoiceL2(ch) {
      /** get Rights Center Choice L1 */
      let DataObj = null;
      DataObj = PatientAdmitRightsCenterChoiceL2.query()
        .where(record => record.emr_ipd_rights_level2_status == "Y")
        .where(record => record.emr_ipd_rights_id == ch)
        .orderBy(record => record.emr_ipd_rights_level2_number)
        .get();
      if (DataObj.length > 0) {
        return DataObj;
      } else {
        return null;
      }
    },
    getRightsCenter(hn, an, act) {
      /** get Rights Center HEAD */
      if (act == "RightsCenterHead") {
        let DataObj2 = null;
        DataObj2 = PatientAdmitRightsCenterHead.query()
          .where(record => record.an == an)
          .where(record => record.hn == hn)
          .get();
        if (DataObj2.length > 0) {
          this.RightsCenterChoiceNote = DataObj2[0].datas.emr_ipd_rights_note;
          this.UserEdit = DataObj2[0].datas.user_edit;
        } else {
          this.RightsCenterChoiceNote = "";
          this.UserEdit = "";
        }
      }

      /** get Rights Center List */
      if (act == "RightsCenterList") {
        let DataObj = null;
        DataObj = PatientAdmitRightsCenterList.query()
          .where(record => record.an == an)
          .where(record => record.hn == hn)
          .get();
        if (DataObj.length > 0) {
          let data = [];
          for (var val of DataObj) {
            data.push(val.emr_ipd_rights_id);
          }

          this.selectedRightsCenterChoice = data;
        } else {
          this.selectedRightsCenterChoice = [];
        }
      }

      /** get Rights Center List L1 */
      if (act == "RightsCenterListL1") {
        let DataObj = null;
        DataObj = PatientAdmitRightsCenterListL1.query()
          .where(record => record.an == an)
          .where(record => record.hn == hn)
          .get();
        if (DataObj.length > 0) {
          let data = [];
          for (var val1 of DataObj) {
            data.push(val1.emr_ipd_rights_level1_id);
          }

          this.selectedRightsCenterChoiceL1 = data;
        } else {
          this.selectedRightsCenterChoiceL1 = [];
        }
      }

      /** get Rights Center List L2 */
      if (act == "RightsCenterListL2") {
        let DataObj = null;
        DataObj = PatientAdmitRightsCenterListL2.query()
          .where(record => record.an == an)
          .where(record => record.hn == hn)
          .get();
        if (DataObj.length > 0) {
          let data = [];
          for (var val2 of DataObj) {
            data.push(val2.emr_ipd_rights_level2_id);
          }

          this.selectedRightsCenterChoiceL2 = data;
        } else {
          this.selectedRightsCenterChoiceL2 = [];
        }
      }
    },
    getRightsCenterListL1Note(an, ch) {
      /** get Rights Center Choice L1 */
      let DataObj = null;
      DataObj = PatientAdmitRightsCenterListL1.query()
        .where(record => record.emr_ipd_rights_level1_id == ch)
        .where(record => record.an == an)
        .get();
      if (DataObj.length > 0) {
        return DataObj[0].datas.emr_ipd_rights_level1_note;
      } else {
        return null;
      }
    },
    filterListL1Note(ch) {
      var lucky = [];

      if (this.selectedRightsCenterL1Note != null) {
        lucky = this.selectedRightsCenterL1Note.filter(item => {
          return item.id == ch;
        });
      } else {
        lucky = [];
      }

      return lucky;
    },
    filterListL2Note(ch) {
      var lucky = [];

      if (this.selectedRightsCenterL2Note != null) {
        lucky = this.selectedRightsCenterL2Note.filter(item => {
          return item.id == ch;
        });
      } else {
        lucky = [];
      }

      return lucky;
    }
  }
})
export default class EmrAdmitRightsData extends Vue {}
</script>

<style lang="scss">
</style>

